<emperor-alert
  [uiAlertType]="EmperorUIAlertType.Warn"
  class="compliance-check-alert"
>
  <div class="alert-message">
    <div>
      Attention: Bold Penguin must conduct a compliance check on your Agency
      Principal before we can offer sub-appointments.
    </div>
    <emperor-button class="no-wrap" (click)="navigateToCompliance()"
      ><span class="uppercase">Start Compliance</span></emperor-button
    >
  </div>
</emperor-alert>
